export default {
  SET_bills(state, value) {
    state.bills = value;
  },
};
